class Tabs {
    constructor() {
      this.tabTriggers = document.querySelectorAll('[data-tab-trigger]');
      this.tabContents = document.querySelectorAll('[data-tab-content]');

      this.tabTriggers.forEach(tab => {
        tab.addEventListener('click', () => this.toggleTab(tab));
      });
    }

    toggleTab(clickedTab) {
        const tabId = clickedTab.dataset.tabTrigger;
    
        this.tabContents.forEach(content => {
            content.removeAttribute('open');
        });
    
        const activeTabContent = document.querySelector(`[data-tab-content="${tabId}"]`);
        if (activeTabContent) {
            activeTabContent.setAttribute('open', '');
        }
    
        this.tabTriggers.forEach(tab => {
            tab.removeAttribute('active');
        });
    
        clickedTab.setAttribute('active', ''); // Add the attribute name 'active' and an empty string as the attribute value
    }    
  }

  const myTabs = new Tabs();




  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      this.activeModal = null;
    }

    connectedCallback() {
      this.modalButtons = document.querySelectorAll('[drawer-trigger]');
      this.modalButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.activeModal = document.getElementById(button.getAttribute('drawer-id'));
          this.activeModal && this.activeModal.hasAttribute('open') 
              ? this.close(this.activeModal) 
              : this.open(this.activeModal);
              
        });
      });

      document.addEventListener('click', (event) => {
        if (this.activeModal && !this.activeModal.contains(event.target)) {
          this.close(this.activeModal);
        }
      });

    }

    open(modal) {
      document.body.classList.add('scroll-hidden');
      if (modal) modal.setAttribute('open', '');
    }

    close(modal) {
      document.body.classList.remove('scroll-hidden');
      if (modal) modal.removeAttribute('open');
    }
  }

  customElements.define('custom-drawer', CustomDrawer);


class SiteTooltip extends HTMLElement {
  constructor() {
    super();
    this.tooltipText = this.getAttribute('text') || 'Tooltip text';
    this.tooltipElement = null;
    this.isVisible = false;
    this.isSticky = this.hasAttribute('data-sticky');
    this.isMobile = window.innerWidth <= 750; // You can adjust the breakpoint
  }

  connectedCallback() {
    if (this.isMobile) return; // Disable tooltip on mobile

    this.addEventListener('mouseenter', this.showTooltip.bind(this));
    this.addEventListener('mouseleave', this.hideTooltip.bind(this));
    window.addEventListener('scroll', this.hideTooltip.bind(this));
    this.addEventListener('touchstart', this.toggleTooltip.bind(this));

    if (this.isSticky) {
      this.showTooltip();
    }
  }

  toggleTooltip(event) {
    event.preventDefault();
    this.isVisible ? this.hideTooltip() : this.showTooltip();
  }

  showTooltip() {
    if (this.tooltipElement) return;

    this.tooltipElement = document.createElement('div');
    this.tooltipElement.className = 'tooltip-box';
    this.tooltipElement.textContent = this.tooltipText;

    document.body.appendChild(this.tooltipElement);

    const rect = this.getBoundingClientRect();
    const tooltipRect = this.tooltipElement.getBoundingClientRect();

    let top = rect.top - tooltipRect.height - 8 + window.scrollY;
    let left = rect.left + rect.width / 2 - tooltipRect.width / 2 + window.scrollX;

    if (top < 0) top = rect.bottom + 8 + window.scrollY;
    if (left < 0) left = 8 + window.scrollX;
    if (left + tooltipRect.width > window.innerWidth) left = window.innerWidth - tooltipRect.width - 8 + window.scrollX;

    this.tooltipElement.style.top = `${top}px`;
    this.tooltipElement.style.left = `${left}px`;

    this.tooltipElement.style.visibility = 'visible';
    this.tooltipElement.style.opacity = '1';
    this.isVisible = true;

    if (this.isSticky) {
      this.tooltipElement.classList.add('sticky');
    }
  }

  hideTooltip() {
    if (this.tooltipElement && !this.isSticky) {
      this.tooltipElement.style.visibility = 'hidden';
      this.tooltipElement.style.opacity = '0';

      setTimeout(() => {
        if (this.tooltipElement) {
          this.tooltipElement.remove();
          this.tooltipElement = null;
        }
        this.isVisible = false;
      }, 300);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.showTooltip);
    this.removeEventListener('mouseleave', this.hideTooltip);
    this.removeEventListener('touchstart', this.toggleTooltip);
  }
}

customElements.define('site-tooltip', SiteTooltip);

document.querySelectorAll('.js-inset-scroll-detector').forEach(container => {
  const initialScrollLeft = container.scrollLeft;

  container.addEventListener('scroll', () => {
    if (container.scrollLeft > initialScrollLeft) {
      container.classList.add('container-scrolled');
    } else {
      container.classList.remove('container-scrolled');
    }
  });
});